export default "__VITE_ASSET__CuSZAP_n__"